<template>
  <div>
    <div class="document-download">
      <div style="flex: 8">
        <p class="file-details">
          <span class="file-type" v-if="document.docType !== 'STIPEND'">{{ document.docType }}</span>
          <br />
          <div class="file-name">
            <button class="file-name-copy" type="button" @click="preventProp" v-clipboard:copy="document.filename">
                <font-awesome-icon
                  class="clipboard"
                  :icon="['fa', 'clipboard']"
                  :style="{ fontSize: '24px' }"
                ></font-awesome-icon>
            </button>
            <span class="filename text-normal text-unbold">
              {{ document.filename }}
            </span>
          </div>
        </p>
      </div>
      <div style="flex: 2">
        <md-button class="md-raised" style="position:relative" @click="toggleDisplayDocument">
          <translate>Open</translate>
        </md-button>
      </div>
      <div style="flex: 2">
        <md-button class="md-raised" style="position:relative">
          <translate>Download</translate>
          <a :href="document.file" class="btn-link" target="_blank" rel="noreferrer noopener"></a>
        </md-button>
      </div>
    </div>

    <Modal
      v-if="displayDocument"
      dimmed
      @close-modal="displayDocument = false"
    >
      <VueDocPreview v-if="['pptx', 'docx', 'doc', 'ppt', 'xls', 'xlsx'].includes(getFileExtension(document.file))" :value="document.file" type="office"/>

      <div v-if="['jpg', 'jpeg', 'png'].includes(getFileExtension(document.file))">
        <img :src="document.file" height="100%" width="100%" />
      </div>

      <div v-show="['pdf'].includes(getFileExtension(document.file))" class="pdf-viewer">
        <vue-pdf-embed
          width="1200"
          :source="document.file"
        />
      </div>
    </Modal>


  </div>
</template>

<script>
/**
 * Document Download Component
 *
 * Displays a document's name and a download button.
 *
 * @prop {Document} document - The document to display
 */
import VueDocPreview from 'vue-doc-preview'
import VueClipboard from 'vue-clipboard2'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'


import Modal from '../components/Modal'

export default {
  name: 'DocumentDownload',
  components: {
    VuePdfEmbed,
    VueDocPreview,
    Modal
  },
  data() {
    return {
      displayDocument: false
    }
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  methods: {
    toggleDisplayDocument(event) {
      this.displayDocument = true
    },
    preventProp(event) {
      event.stopPropagation()
    },
    getFileExtension(filename) {
      return filename.split(/[#?]/)[0].split('.').pop().trim();
    }
  }
}
</script>

<style lang="scss">
@import '../styles/variables';


.vue-pdf-embed > div {
  margin-bottom: 8px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}

.pdf-viewer {
  height: 80vh;
  width: auto;
}

.file-name {
  display: flex;
  align-items: center;
  margin-left: 1rem;
  margin-right: 1rem;
}

.file-type {
  margin-left: 1rem;
}

.file-name-copy {
  margin-right: 1rem;
}

.file-name-copy:focus {
  color: #4d4e4c;
}

.document-download {
  display: flex;
  border-top: 1px solid $soft-gray;
  padding: 1rem 0;

  &:hover {
    background-color: $off-white;
  }
}

.btn-link {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
</style>
